module.exports = __webpack_public_path__ + "media/customizations/wildblue/logo-new-42ee33328479696f7f42c1457468f317.png";